import React from 'react';
import { recipeBookPanelClassName } from './recipeBookStyles';

function StatBlock({ label, value, loading }) {
	return (
		<div>
			<p className="text-xs font-bold uppercase tracking-wider text-gray-500 dark:text-gray-400">
				{label}
			</p>
			<p className="mt-1 text-2xl font-bold tracking-tight text-gray-900 dark:text-dark-text tabular-nums">
				{loading ? '—' : value}
			</p>
		</div>
	);
}

export default function RecipeBookSummaryBar({ meta, loading }) {
	if (!meta && loading) {
		return (
			<div className={`${recipeBookPanelClassName} px-6 py-5 animate-pulse`}>
				<div className="grid grid-cols-2 gap-6 sm:grid-cols-4">
					{[1, 2, 3, 4].map((i) => (
						<div key={i} className="h-12 rounded-lg bg-gray-100 dark:bg-dark-border" />
					))}
				</div>
			</div>
		);
	}

	if (!meta) return null;

	return (
		<div className={`${recipeBookPanelClassName} px-6 py-5`}>
			<div className="grid grid-cols-2 gap-6 sm:grid-cols-4">
				<StatBlock label="Total recipes" value={meta.total ?? 0} loading={loading} />
				<StatBlock label="Healthiest" value={meta.health_first_count ?? 0} loading={loading} />
				<StatBlock label="Balanced" value={meta.balanced_count ?? 0} loading={loading} />
				<StatBlock label="Treat" value={meta.indulgent_last_count ?? 0} loading={loading} />
			</div>
		</div>
	);
}
